// extracted by mini-css-extract-plugin
export default {"items":"default-adjustment-options-module__items--MBrBt","gap":"default-adjustment-options-module__gap--dGC8y","container":"default-adjustment-options-module__container--X5co4"};